import { createTupleOptions } from "@magicware/forms/mui/FormSelect";

export const environmentOptions = createTupleOptions([
    ["Testing", "Testing"],
    ["Staging", "Staging"],
    ["Production", "Production"],
]);
